import { Button, Text, makeStyles } from '@rneui/themed'
import { t } from 'app/i18l'
import { font } from 'app/theme'
import React from 'react'
import { View } from 'react-native'

interface Props {
  onLogout?: () => Promise<void>
}

export function PendingView({ onLogout }: Props) {
  const styles = useStyles()
  return (
    <View style={styles.container}>
      <Text style={styles.errorMessage}>{t('pendingMessage')}</Text>
      {onLogout && (
        <Button
          containerStyle={styles.buttonContainer}
          buttonStyle={styles.button}
          titleStyle={styles.buttonTitle}
          title={t('signOut')}
          onPress={onLogout}
        />
      )}
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    flex: 1,
    marginTop: 16,
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingHorizontal: 30,
  },
  errorMessage: {
    marginTop: 100,
    textAlign: 'center',
    fontSize: 20,
  },
  buttonContainer: {
    marginTop: 20,
  },
  button: {
    backgroundColor: theme.colors.red,
  },
  buttonTitle: {
    fontFamily: font.bold,
  },
}))
